import React, { useState, ReactNode } from 'react';
import { Icon } from '@material-ui/core';
import styles from './styles.module.scss';

interface CollapseProps {
  open?: boolean;
  title: string | ReactNode;
  disabled?: boolean;
  testId?: string;
}

const Collapse: React.FC<CollapseProps> = ({ open = false, children, title, disabled = false, testId }) => {
  const [isOpened, setIsOpened] = useState(open && !disabled);

  return (
    <div className={styles.card}>
      <div className={`styles.cardInnerContainer ${disabled ? styles.disabled : styles.enabled}`}>
        <span className={styles.cardTitle}>{title}</span>
        <span
          aria-hidden="true"
          role="button"
          onClick={(): void => setIsOpened(!isOpened && !disabled)}
          className={styles.cardIconContainer}
          data-testid={testId ? `collapsible-toggle-${testId}` : undefined}
        >
          <Icon fontSize="medium">{!isOpened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
        </span>
      </div>

      <div className="border-bottom">
        <div>{isOpened && <div className="p-3">{children}</div>}</div>
      </div>
    </div>
  );
};

export default Collapse;
